module.exports = __webpack_public_path__ + "img/nice-logo-icon.13a922a6.png";